export default __webpack_public_path__ + "static/media/bg-1.a8964916.jpg";